<form (ngSubmit)="formSubmit()" #form [class.submitted]="form.submitted">
  <modal
    *ngLet="load || { loading: loading, erred: erred } as loadable"
    [title]="title"
    [width]="width"
    [outerWidth]="outerWidth"
    (close)="close.emit()"
    (closeMethodRef)="closeMethodRef = $event"
    [backgroundShading]="backgroundShading"
    [invertedColors]="invertedColors"
  >
    <loadable class="non-relative" [data]="loadable">
      <ng-content></ng-content>
    </loadable>
    <footer class="rv-button-set">
      <button
        rivButton
        [variant]="'ghost'"
        [size]="'medium'"
        (click)="$event.preventDefault(); setCancelCloseMethod(); close.emit()"
        title="Cancel"
        type="button"
      >
        {{ cancelText }}
      </button>
      <button
        rivButton
        [variant]="'danger'"
        [size]="'medium'"
        [disabled]="
          submitting || disableDelete || loadable.loading || loadable.erred
        "
        type="submit"
      >
        {{ submitting ? 'Deleting...' : submitText }}
      </button>
    </footer>
  </modal>
</form>
